module.exports = __webpack_public_path__ + "0662243028e790e6a1df045e13efe75f.pdf";